import { type ReactNode } from 'react';
import * as React from 'react';
import styled from 'styled-components';

import { LinkWithQuery } from '../global/LinkWithQuery';

const LinkWrapper = styled(LinkWithQuery)`
  ${({ theme }) => theme.banner};
`;

const Wrapper = styled.div`
  ${({ theme }) => theme.banner};
`;

interface BannerProps {
  children: ReactNode;
  className?: string;
  to?: string;
}

export const Banner: React.ComponentType<BannerProps> = React.memo(
  ({ children, className, to }) => {
    if (to) {
      return (
        <LinkWrapper className={className} to={to}>
          {children}
        </LinkWrapper>
      );
    }
    return <Wrapper className={className}>{children}</Wrapper>;
  }
);
